import React from 'react'
import { GenericOrderBy, GenericTable } from '../_EOS/Table'
import { WorkOrderBlog } from '../../interfaces/WorkOrder/WorkOrderBlog'
import { workOrderBlogTableHeaderConfig } from './config'
import { Box, Paper } from '@mui/material'

interface WorkOrderBlogProps {
  workOrderBlogs: WorkOrderBlog[]
  isLoading: boolean
  orderBy?: GenericOrderBy<WorkOrderBlog>
  onSortChange?: (orderBy: GenericOrderBy<WorkOrderBlog>) => void
}

export const WorkOrderBlogTable: React.FC<WorkOrderBlogProps> = ({
  workOrderBlogs,
  isLoading,
  orderBy,
  onSortChange
}) => {
  return (
    <Box
      overflow={'auto'}
      maxHeight={'250px'}
      component={Paper}
      sx={{
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 'none'
      }}
    >
      <GenericTable<WorkOrderBlog>
        headersConfig={workOrderBlogTableHeaderConfig}
        data={workOrderBlogs}
        IDKey={'workOrderBlogId'}
        noResultsText='Aun no existen registros en bitácora'
        isLoading={isLoading}
        orderField={orderBy}
        onSortChange={onSortChange}
      />
    </Box>
  )
}
